var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUfoBalun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 242.198,
    height: 161.291,
    viewBox: "0 0 242.198 161.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.418,
    x2: 0.5,
    y2: 1.934,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff8f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -78.912,
    y1: -0.418,
    x2: -78.912,
    y2: 1.934,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ufo-balun",
    transform: "translate(-14.561 -7167.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50857",
    "data-name": "Path 50857",
    d: "M245.961,336.93a11.349,11.349,0,0,0-6.018,1.716,15.189,15.189,0,0,0-23.45-5.915,22.869,22.869,0,0,0-44.782-.895,15.188,15.188,0,0,0-23.42,12.778H256.759A11.437,11.437,0,0,0,245.961,336.93Z",
    transform: "translate(0 6932.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50858",
    "data-name": "Path 50858",
    d: "M24.252,389.709a10.2,10.2,0,0,1,5.4,1.541A13.631,13.631,0,0,1,50.7,385.941a20.524,20.524,0,0,1,40.19-.8,13.631,13.631,0,0,1,21.019,11.468H14.561A10.266,10.266,0,0,1,24.252,389.709Z",
    transform: "translate(0 6932.5)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11196",
    "data-name": "Group 11196",
    transform: "translate(0 6932.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11187",
    "data-name": "Group 11187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50863",
    "data-name": "Path 50863",
    d: "M111.87,331.522a.42.42,0,0,1-.42-.42V317a.42.42,0,1,1,.84,0v14.1A.42.42,0,0,1,111.87,331.522Z",
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50864",
    "data-name": "Path 50864",
    d: "M142.894,245.549c-12.728-7.376-31.024-6.689-31.024-6.689s-18.3-.687-31.025,6.689c-13.431,7.785-18.368,21.7-9.979,37.9s30.482,35.581,30.482,35.581h21.044s22.093-19.382,30.482-35.581S156.326,253.334,142.894,245.549Z",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11188",
    "data-name": "Group 11188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50865",
    "data-name": "Path 50865",
    d: "M112.277,238.86s.377-.014,1.06-.016c-.6,0-1.03.005-1.264.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50866",
    "data-name": "Path 50866",
    d: "M71.272,283.444c-8.388-16.2-3.451-30.11,9.98-37.9,10.567-6.124,24.971-6.69,29.558-6.705-4.074-.015-19.062.387-29.965,6.705-13.431,7.785-18.368,21.7-9.979,37.9s30.482,35.581,30.482,35.581h.406S79.661,299.643,71.272,283.444Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50867",
    "data-name": "Path 50867",
    d: "M122.392,319.025s22.093-19.382,30.482-35.581,3.452-30.11-9.98-37.9c-12.728-7.376-31.024-6.689-31.024-6.689v80.165Z",
    fill: "#b58335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50868",
    "data-name": "Path 50868",
    d: "M142.894,245.549c-10.948-6.344-26.015-6.723-30.015-6.705,4.639.019,18.979.6,29.509,6.705,13.431,7.785,18.369,21.7,9.98,37.9s-30.482,35.581-30.482,35.581h.506s22.093-19.382,30.482-35.581S156.326,253.334,142.894,245.549Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50869",
    "data-name": "Path 50869",
    d: "M134.788,243.291c-9.4-7.875-22.918-7.142-22.918-7.142s-13.516-.733-22.919,7.142c-9.922,8.311-13.569,23.163-7.372,40.458,4.843,13.517,15.87,29.108,20.457,35.276H121.7c4.587-6.168,15.613-21.759,20.457-35.276C148.358,266.454,144.71,251.6,134.788,243.291Z",
    fill: "#b58335"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11190",
    "data-name": "Group 11190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11189",
    "data-name": "Group 11189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50870",
    "data-name": "Path 50870",
    d: "M112.451,236.149s.226-.012.634-.016c-.406,0-.719,0-.925.006C112.346,236.144,112.451,236.149,112.451,236.149Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50871",
    "data-name": "Path 50871",
    d: "M89.533,243.291c7.71-6.458,18.182-7.126,21.7-7.158-2.772-.03-14.088.294-22.284,7.158-9.922,8.311-13.569,23.163-7.372,40.458,4.843,13.517,15.87,29.108,20.457,35.276h.581C98.03,312.857,87,297.266,82.16,283.749,75.963,266.454,79.611,251.6,89.533,243.291Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_50872",
    "data-name": "Path 50872",
    d: "M121.7,319.025c4.587-6.168,15.613-21.759,20.457-35.276,6.2-17.295,2.549-32.147-7.373-40.458-9.4-7.875-22.918-7.142-22.918-7.142v82.876Z",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50873",
    "data-name": "Path 50873",
    d: "M134.788,243.291c-8.248-6.908-19.658-7.192-22.337-7.157,3.61.042,13.971.755,21.614,7.157,9.922,8.311,13.569,23.163,7.372,40.458-4.843,13.517-15.869,29.108-20.456,35.276h.723c4.587-6.168,15.613-21.759,20.457-35.276C148.358,266.454,144.71,251.6,134.788,243.291Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50874",
    "data-name": "Path 50874",
    d: "M116.76,319.025c2.291-6.735,7.176-21.937,9.368-35.184,2.917-17.625,1.2-32.76-3.47-41.229-4.426-8.025-10.788-7.278-10.788-7.278s-6.362-.747-10.788,7.278c-4.671,8.469-6.388,23.6-3.47,41.229,2.192,13.247,7.077,28.449,9.368,35.184Z",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11191",
    "data-name": "Group 11191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50875",
    "data-name": "Path 50875",
    d: "M101.556,242.612c3.555-6.445,8.355-7.231,10.109-7.291-1.115-.047-6.623.11-10.583,7.291-4.671,8.469-6.388,23.6-3.47,41.229,2.192,13.247,7.077,28.449,9.368,35.184h.474c-2.291-6.735-7.175-21.937-9.368-35.184C95.169,266.216,96.886,251.081,101.556,242.612Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50876",
    "data-name": "Path 50876",
    d: "M116.76,319.025c2.291-6.735,7.176-21.937,9.368-35.184,2.917-17.625,1.2-32.76-3.47-41.229-3.393-6.151-7.92-7.147-9.85-7.278h-.938v83.691Z",
    fill: "#b58335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50877",
    "data-name": "Path 50877",
    d: "M122.658,242.612c-3.393-6.151-7.92-7.147-9.85-7.278h-.615c1.93.131,6.458,1.127,9.85,7.278,4.671,8.469,6.387,23.6,3.47,41.229-2.192,13.247-7.076,28.449-9.368,35.184h.615c2.291-6.735,7.176-21.937,9.368-35.184C129.045,266.216,127.328,251.081,122.658,242.612Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50878",
    "data-name": "Path 50878",
    d: "M122.392,319.025c0,1.118-4.711,2.024-10.522,2.024s-10.522-.906-10.522-2.024S106.059,317,111.87,317,122.392,317.906,122.392,319.025Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50879",
    "data-name": "Path 50879",
    d: "M111.87,317.434c5.43,0,9.9.791,10.461,1.808a.444.444,0,0,0,.061-.217c0-1.119-4.711-2.025-10.522-2.025s-10.522.906-10.522,2.025a.453.453,0,0,0,.06.217C101.971,318.225,106.44,317.434,111.87,317.434Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11192",
    "data-name": "Group 11192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50880",
    "data-name": "Path 50880",
    d: "M105.759,332.459a.421.421,0,0,1-.4-.284l-4.351-12.8a.42.42,0,0,1,.8-.271l4.35,12.8a.419.419,0,0,1-.262.533A.424.424,0,0,1,105.759,332.459Z",
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11193",
    "data-name": "Group 11193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50881",
    "data-name": "Path 50881",
    d: "M109.084,332.082a.421.421,0,0,1-.413-.35l-2.344-13.972a.42.42,0,1,1,.828-.139l2.344,13.972a.418.418,0,0,1-.344.483A.426.426,0,0,1,109.084,332.082Z",
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11194",
    "data-name": "Group 11194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50882",
    "data-name": "Path 50882",
    d: "M118.042,332.459a.43.43,0,0,1-.136-.022.42.42,0,0,1-.262-.533l4.351-12.8a.42.42,0,1,1,.795.271l-4.351,12.8A.421.421,0,0,1,118.042,332.459Z",
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11195",
    "data-name": "Group 11195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50883",
    "data-name": "Path 50883",
    d: "M114.716,332.082a.426.426,0,0,1-.071-.006.419.419,0,0,1-.344-.483l2.345-13.972a.426.426,0,0,1,.484-.345.419.419,0,0,1,.344.484l-2.345,13.972A.419.419,0,0,1,114.716,332.082Z",
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50884",
    "data-name": "Path 50884",
    d: "M117.221,345.384h-10.7a2.071,2.071,0,0,1-2.071-2.07V331.1h14.843v12.212A2.07,2.07,0,0,1,117.221,345.384Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50885",
    "data-name": "Path 50885",
    d: "M116.9,345.384h-10.07a2.07,2.07,0,0,1-2.07-2.07V331.1h14.21v12.212A2.07,2.07,0,0,1,116.9,345.384Z",
    fill: "#b58335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50886",
    "data-name": "Path 50886",
    d: "M113.135,345.384H110.6a2.07,2.07,0,0,1-2.07-2.07V331.1h6.672v12.212A2.071,2.071,0,0,1,113.135,345.384Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50887",
    "data-name": "Path 50887",
    d: "M112.8,345.384h-1.862a2.07,2.07,0,0,1-2.07-2.07V331.1h6v12.212A2.07,2.07,0,0,1,112.8,345.384Z",
    fill: "#c09342"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50888",
    "data-name": "Path 50888",
    d: "M119.77,332.977h-15.8a.938.938,0,0,1-.937-.938h0a.938.938,0,0,1,.937-.937h15.8a.938.938,0,0,1,.937.937h0A.938.938,0,0,1,119.77,332.977Z",
    fill: "#e5e5e5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfoBalun);
export default __webpack_public_path__ + "static/media/ufo-balun.7e1c6e1acc5d903bc97912b5c5c0c6eb.svg";
export { ForwardRef as ReactComponent };